module.exports = __webpack_public_path__ + "img/area_2.7aaccfe0.svg";